import { fox } from '../beasts';
import { drift, flame } from '../motifs';
import { registerPlate } from '../registry';

const VIOLET = ['#d8b8ff', '#9a64e0', '#5a2e9a'] as const;
const FOXFIRE = ['#6a3aa8', '#b080f0', '#f4ecff'] as const;

/** 13 จิ้งจอกเก้าหาง: the nine-tailed fox's plate, a violet fox spirit on dark violet lacquer. */
registerPlate({
  id: 'fox',
  name: 'จิ้งจอกเก้าหาง',
  ground: ['#40306a', '#261a44', '#160e2a'],
  trim: '#9a7ad0',
  text: { fill: ['#f4ecff', '#c8b0f0'], line: '#0e0818' },
  inset: [21, 11],
  tassels: [
    { x: 3, tones: VIOLET, charm: 'knot' },
    { x: -4, tones: VIOLET, charm: 'jade', charmTones: ['#e8d8ff', '#a070e0', '#5a2e9a'], len: 9, cord: 3 },
  ],
  front(p, f) {
    fox(p, f.x + 6, f.b - 1, 1.3, false);
    flame(p, f.r - 3, f.y + 2, 9, 4, 1, FOXFIRE);
  },
  motion: {
    sprites: {
      wisp: { w: 4, h: 6, draw: (p) => flame(p, 2, 6, 6, 3, 0, FOXFIRE) },
    },
    play(a, t, f) {
      // Foxfire rising from the spirit's tails and the right end.
      drift(a, 'wisp', t, 3, f.x - 10, 20, f.y + 4, f.y - 14, { speed: 0.35, sway: 2 });
      drift(a, 'wisp', t, 1, f.r - 5, 2, f.y, f.y - 10, { speed: 0.4, seed: 5 });
    },
  },
});
